export const SET_PFS_PARAMS = "SET_PFS_PARAMS";
export const CLEAR_PFS_PARAMS = "CLEAR_PFS_PARAMS";

/**
 * Action pour définir les paramètres PFS
 * @param {Object} params - Paramètres PFS à stocker
 */
export const setPfsParams = params => ({
	type: SET_PFS_PARAMS,
	payload: params,
});

/**
 * Action pour effacer les paramètres PFS
 */
export const clearPfsParams = () => ({
	type: CLEAR_PFS_PARAMS,
});
